import * as z from 'zod/v4';
import { EnumParams } from '../events.types';
import { MODES_REQUIRING_ELEMENT } from './combat-consts';

export const APPLIES_TO_VALUES = ['Player', 'Enemy', 'Both'] as const;

export const combatModifiersSectionSchema = (enums?: EnumParams) =>
  z.object({
    statType: enums ? z.enum(enums.CombatStatType) : z.string(),
    modifier: z
      .number()
      .min(-100)
      .max(1000)
      .refine(v => v !== 0, { message: 'Modifier cannot be 0' }),
    appliesTo: z.enum(APPLIES_TO_VALUES),
    inModes: z.array(
      z
        .object({
          gameMode: enums ? z.enum(enums.GameMode) : z.string(),
          element: enums ? z.enum(enums.CombatTag).optional() : z.string().optional(),
        })
        .refine(
          row => {
            const requiresElement = (MODES_REQUIRING_ELEMENT as readonly string[]).includes(
              row.gameMode,
            );
            return requiresElement ? row.element !== undefined : row.element === undefined;
          },
          {
            message:
              'Element is required for DailyDungeon and GuildBoss, and must be absent for other modes',
          },
        ),
    ),
  });
